<footer class="footer">
  <p>{{ footerText }}</p>
</footer>
